module.exports = __webpack_public_path__ + "img/s08-min.10cf478b.png";